import http from '@/publicResource/server/httpServer.js'
import CryptoJS from 'crypto-js'

/**
 * 用户登录
 * @return {promise}
 */

/* 省市县地址选择 */
export const searchAreasInfo = data => {
  return http(
    {
      url: '/userGateway/area/searchAreasInfo',
      method: 'post'
    },
    data
  )
}
/* 密码验证 */
export const authQueryPw = data => {
  return http(
    {
      url: '/arbit/filing/checkQueryPassword',
      method: 'post'
    },
    data
  )
}
/* 获取案件进度查询信息 */
export const queryFilingProgress = data => {
  return http(
    {
      url: '/arbit/filing/queryFilingProgress',
      method: 'post'
    },
    data
  )
}
/* 个人中心-用户资料 */
export const updateCommonUser = data => {
  return http(
    {
      url: '/userGateway/user/updateCommonUser',
      method: 'post'
    },
    data
  )
}

/* 个人中心-用户资料返回值 */
export const searchCommonUser = data => {
  return http(
    {
      url: '/userGateway/user/searchCommonUser',
      method: 'post'
    },
    data
  )
}

/* 个人中心-安全设置-修改密码 */
export const updatePassword = data => {
  return http(
    {
      url: '/userGateway/user/updatePassword',
      method: 'post'
    },
    data
  )
}

/* 个人中心-安全设置-绑定手机 */
export const updateMobilePhone = data => {
  return http(
    {
      url: '/userGateway/user/updateMobilePhone',
      method: 'post'
    },
    data
  )
}

/* 个人中心-安全设置-绑定邮箱 */
export const updateEmail = data => {
  return http(
    {
      url: '/userGateway/user/updateEmail',
      method: 'post'
    },
    data
  )
}

/* 个人中心-安全设置-获取验证码 */
export const getSMSCode = data => {
  return http(
    {
      url: '/userGateway/user/getSMSCode',
      method: 'post'
    },
    data
  )
}

/* 个人中心-个人中心-咨询列表 */
export const getConsultationListPage = data => {
  return http(
    {
      url: 'userGateway/personalCenter/getConsultationListPage',
      method: 'post'
    },
    data
  )
}
/* 个人中心-个人中心-调解列表 */
export const getMediationListPage = data => {
  return http(
    {
      url: 'userGateway/personalCenter/getMediationListPage',
      method: 'post'
    },
    data
  )
}
/* 个人中心-个人中心-诉讼列表 */
export const getSuitInfoListPage = data => {
  return http(
    {
      url: 'userGateway/personalCenter/getSuitInfoListPage',
      method: 'post'
    },
    data
  )
}

/* 个人中心-个人中心-司法确认 */
export const getJudicialConfirmListPage = data => {
  return http(
    {
      url: 'userGateway/personalCenter/getJudicialConfirmListPage',
      method: 'post'
    },
    data
  )
}

/* 个人中心-个人中心-小红点 */
export const getPersonalRedSpot = data => {
  return http(
    {
      url: 'userGateway/personalCenter/getPersonalRedSpot',
      method: 'post'
    },
    data
  )
}

/* 个人中心-个人中心-纠纷详情 */
export const getMediationInfo = data => {
  return http(
    {
      url: 'mastiff/mediation/getMediationInfo',
      method: 'post'
    },
    data
  )
}
// 人脸验证
export const faceAuthentication = data => {
  return http(
    {
      url: '/userGateway/user/faceAuthentication',
      method: 'post'
    },
    data
  )
}
// 申请评估报告
export const applyEvaluateReport = data => {
  return http(
    {
      url: 'mastiff/evaluate/applyEvaluateReport',
      method: 'post'
    },
    data
  )
}
/* 个人中心-咨询列表-人工咨询 */
export const getUserSelectCounselor = data => {
  return http(
    {
      url: 'panda/disputes/getUserSelectCounselor',
      method: 'post'
    },
    data
  )
}
/* 获取公道跳转 */
export const gongdaoLoginSkip = () => {
  return http({
    url: '/userGateway/user/gongdaoLoginSkip',
    method: 'get'
  })
}
/* 获取公道信息跳转 */
export const getGongdaoLoginToken = (code, state) => {
  return http({
    url: 'userGateway/user/getGongdaoLoginToken?code=' + code + '&state=' + state,
    method: 'get'
  })
}

/* 个人中心-咨询列表-评估 */
export const getEvaluateList = data => {
  return http(
    {
      url: 'mastiff/evaluate/getEvaluateList',
      method: 'post'
    },
    data
  )
}
/* 个人中心-调解列表-调解进度 */
export const getMediationProgress = data => {
  return http(
    {
      url: 'mastiff/mediation/getMediationProgress',
      method: 'post'
    },
    data
  )
}

/* 个人中心-调解列表-纠纷详情-纠纷编辑 */
export const editCaseDisputeInfo = data => {
  return http(
    {
      url: 'mastiff/case/editCaseDisputeInfo',
      method: 'post'
    },
    data
  )
}

/* 个人中心-调解列表-纠纷详情-删除 */
export const delFile = data => {
  return http(
    {
      url: 'mastiff/lawCaseDossier/delFile',
      method: 'post'
    },
    data
  )
}

/* 个人中心-调解列表-纠纷详情-编辑单个 */
export const saveCaseUser = data => {
  return http(
    {
      url: 'mastiff/case/saveCaseUser',
      method: 'post'
    },
    data
  )
}


// 修改当事人-前置判断
export const findExistUser = (data) => {
  return http({
    url: '/mastiff/case/findExistUser'
  }, data)
}

/* 个人中心-调解列表-纠纷详情-删除当事人 */
export const deleteCaseUser = data => {
  return http(
    {
      url: '/mastiff/case/deleteCaseUser',
      method: 'post'
    },
    data
  )
}

/* 申请诉讼 */
export const getSuitBaseInfo = data => {
  return http(
    {
      url: '/arbit/suit/getSuitBaseInfo',
      method: 'post'
    },
    data
  )
}
/* 司法确认申请 */
export const OnlineFiling = data => {
  return http(
    {
      url: '/arbit/filing/OnlineFiling',
      method: 'post'
    },
    data
  )
}
/* 获取案由 - 申请诉讼 */
export const getlawCause = (data, jsonfile) => {
  return http(
    {
      url: '/arbit/lawCause/' + jsonfile,
      method: 'get'
    },
    data
  )
}
/* 调解申请书列表获取 */
export const getMediationApplyListPage = data => {
  return http(
    {
      url: '/userGateway/personalCenter/getMediationApplyListPage',
      method: 'post'
    },
    data
  )
}

/* 调解失败案件列表 */
export const getFilingListPage = data => {
  return http(
    {
      url: '/userGateway/personalCenter/getFilingListPage',
      method: 'post'
    },
    data
  )
}
/* 提交诉讼 - 申请诉讼 */
export const saveSuit = data => {
  return http(
    {
      url: '/arbit/suit/saveSuit',
      method: 'post'
    },
    data
  )
}
// 二维码登录
export const getQrcode = data => {
  return http(
    {
      url: '/userGateway/user/getQrCodeLoginToken/' + data,
      method: 'get'
    },
    data
  )
}
// 二维码生成
export const getQrcodeimg = data => {
  return http(
    {
      url: '/userGateway/user/showLoginQrCode/' + data,
      method: 'get'
    },
    data
  )
}
/* 纠纷编辑- 纠纷保存 */
export const saveCaseUserList = data => {
  return http(
    {
      url: '/mastiff/case/saveCaseUserList',
      method: 'post'
    },
    data
  )
}

/* 诉讼详情 */
export const suitDetail = data => {
  return http(
    {
      url: '/arbit/suit/suitDetail',
      method: 'post'
    },
    data
  )
}

/* 撤回调解 */
export const retractCase = data => {
  return http(
    {
      url: '/mastiff/case/retractCase',
      method: 'post'
    },
    data
  )
}

/* 获取司法确认申请书 */
export const getJudicialConfirmBook = data => {
  return http(
    {
      url: '/mastiff/judicialConfirm/getJudicialConfirmBook',
      method: 'post'
    },
    data
  )
}

/* 获取自定义纠纷格式 */
export const searchTemplateData = data => {
  return http(
    {
      url: 'https://devftls.odrcloud.net/caseManageSystem/template/searchTemplateData',
      // url: 'https://www.easy-mock.com/mock/5b9cea83c97c69315f3d7c52/searchTemplateData',
      method: 'post'
    },
    data
  )
}

/* 模板提交数据接口 */
export const centerSaveCase = data => {
  return http(
    {
      // url: 'http://192.168.31.141:8084/mastiff/centerCase/saveCase',
      url: '/mastiff/centerCase/saveCase',
      method: 'post'
    },
    data
  )
}

/* 信访代理人-授权书提交 */
export const uploadAuthorizeProxy = data => {
  return http(
    {
      url: '/mastiff/file/uploadAuthorizeProxy',
      method: 'post'
    },
    data
  )
}

/* 个人中心查询信访代理人信息 */
export const searchCommonUserByUserId = data => {
  return http(
    {
      url: '/userGateway/user/searchCommonUserByUserId',
      method: 'post'
    },
    data
  )
}

/* 代理人授权书上传 */
export const uploadAgentAuthorizeProxy = data => {
  return http(
    {
      url: '/mastiff/file/uploadAgentAuthorizeProxy',
      method: 'post'
    },
    data
  )
}

/* 国籍国家 */
export const getDictByPre = data => {
  return http({
    url: `/mastiff/case/getDictByPre?pre=${data}`,
    method: 'get'
  })
}

/* 诉讼列表 */
export const listSuitV2 = data => {
  return http(
    {
      url: `/arbit/suit/listSuitV2`,
      method: 'post'
    },
    data
  )
}

/**
 * @description: 校验证书并生成随机数
 * @param {string} data.userSignCertB64
 * @param {string} data.container
 */
export const validateCertGenRandom = data => {
  return http(
    {
      url: '/userGateway/user/validateCertGenRandom',
      method: 'post'
    },
    data
  )
}

/**
 * @description: 用户通过证书登录
 * @param {string} data.signedDataB64
 * @param {string} data.userSignCert
 * @param {string} data.randomData
 */
export const userLoginByCert = data => {
  return http(
    {
      url: '/userGateway/user/userLoginByCert',
      method: 'post'
    },
    data
  )
}

/**
 * @description: 海南国商单点登录获取token
 * 100047 e187f36ce2ea77b7
 */
export const getHngsSsoToken = token => {
  const timestamp = new Date().getTime()
  const signature = CryptoJS.SHA256(timestamp + '100047' + 'e187f36ce2ea77b7')
    .toString(CryptoJS.enc.Hex)
    .toUpperCase()
  return http(
    {
      url: '/mastiff/thirdPartyV2/getToken',
      method: 'get',
      headers: {
        appid: 100047,
        signature,
        timestamp
      }
    },
    { token }
  )
}

/**
 * @description: 获取涉外的jwttoken和对应的权限
 */
export const getHnswToken = (accesstoken, params) => {
  const timestamp = new Date().getTime()
  const signature = CryptoJS.SHA256(timestamp + '100047' + 'e187f36ce2ea77b7')
    .toString(CryptoJS.enc.Hex)
    .toUpperCase()
  return http(
    {
      url: '/mastiff/thirdPartyV2/obtainCertificate',
      method: 'post',
      headers: {
        appid: 100047,
        timestamp,
        signature,
        accesstoken
      }
    },
    { params }
  )
}



// WEBPACK FOOTER //
// ./src/publicResource/api/apiUser.js